import React from 'react';
import FilterTable from './filterTable';

const FeaturesTable = (props) => {
  const featureTypesFilterValues = { all: '' };
  for (let key in props.featureTypes) {
    featureTypesFilterValues[props.featureTypes[key]] = props.featureTypes[key];
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Id',
      sort: true,
      filter_: { type: 'text' },
    },
    {
      dataField: 'featureTypesStr',
      text: 'Type',
      sort: true,
      filter_: {
        type: 'select',
        values: featureTypesFilterValues,
      },
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      filter_: { type: 'text' },
    },
  ];

  const defaultSorted = [
    {
      dataField: 'id',
      order: 'asc',
    },
  ];

  let features = props.features.map(feature => {
    return { ...feature, featureTypesStr: props.featureTypes[feature.type] };
  });

  return (
    <FilterTable
      {...props}
      objectName={'features'}
      data={features}
      columns={columns}
      noDataIndication="There are no features"
      defaultSorted={defaultSorted}
    />
  );
};

export default FeaturesTable;



// WEBPACK FOOTER //
// ./src/components/featuresTable.js